import { render, staticRenderFns } from "./CustomerCallBtn.vue?vue&type=template&id=6602dc14&"
import script from "./CustomerCallBtn.vue?vue&type=script&lang=js&"
export * from "./CustomerCallBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports